import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const ifAuthenticated = async (to, from, next) => {
  if (store.state.token) {
    next();
  }else if (store.state.haveUserData == false && store.state.user.role == 0) {
    next("profile");
  } else {
    next("home");
  }
};

const ifAuthenticated0 = async (to, from, next) => {
  if (store.state.token && store.state.user.role == 0) {
    next();
  } else if (store.state.haveUserData == false) {
    next("profile");
  } else {
    next("home");
  }
};

const ifAuthenticated50 = async (to, from, next) => {
  if (store.state.token && store.state.user.role == 50) {
    next();
  } else {
    next("home");
  }
};

const ifAuthenticated60Upto = async (to, from, next) => {
  if (store.state.token && (store.state.user.role == 60 || store.state.user.role == 80)) {
    next();
  } else {
    next("home");
  }
};

const ifAuthenticated50Upto = async (to, from, next) => {
  if (store.state.token && (store.state.user.role == 50 || store.state.user.role == 60 || store.state.user.role == 80)) {
    next();
  } else {
    next("home");
  }
};

const ifAuthenticated0Upto = async (to, from, next) => {
  if (store.state.token && (store.state.user.role == 0 || store.state.user.role == 50 || store.state.user.role == 60 || store.state.user.role == 80)) {
    next();
  } else {
    next("home");
  }
};

const ifhaveUserData = async (to, from, next) => {
  if (!store.state.token) {
    next();
  }else if (store.state.haveUserData == false && store.state.user.role != 60) {
    next("profile");
  } else {
    next();
  }
};

let router = new Router({
  mode: "history",
  routes: [
    { path: "*", component: () => import("@/views/ErrorScreen") },
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/Home"),
      beforeEnter: ifhaveUserData,
    },
    {
      path: "/signin",
      name: "signin",
      component: () => import("@/views/Signin"),
    },
    {
      path: "/signup",
      name: "signup",
      component: () => import("@/views/Signup"),
    },
    {
      path: "/signup/step",
      name: "signupStep",
      component: () => import("@/views/SignupStep"),
    },
    {
      path: "/forgot/password",
      name: "forgotPassword",
      component: () => import("@/views/ForgotPassword"),
    },
    {
      path: "/reset/password/:code",
      name: "resetPassword",
      component: () => import("@/views/ResetPassword"),
    },
    {
      path: "/course/detail",
      name: "courseDetail",
      props: (route) => ({
        routeParams: route.query,
      }),
      meta: {},
      component: () => import("@/views/CourseDetail"),
    },
    {
      path: "/course/learn",
      name: "courseLearn",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated0Upto,
      component: () => import("@/views/CourseLearn"),
    },
    {
      path: "/course/test",
      name: "courseTest",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated0Upto,
      component: () => import("@/views/CourseTest"),
    },
    {
      path: "/discussion/forum",
      name: "discussionForum",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated0Upto,
      component: () => import("@/views/DiscussionForum"),
    },
    {
      path: "/create/discussion/forum",
      name: "createDiscussionForum",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated0Upto,
      component: () => import("@/views/CreateDiscussionForum"),
    },
    {
      path: "/discussion/forum/detail",
      name: "discussionForumDetail",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated,
      component: () => import("@/views/DiscussionForumDetail"),
    },
    {
      path: "/assignment",
      name: "assignment",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated0Upto,
      component: () => import("@/views/Assignment"),
    },
    {
      path: "/feedback",
      name: "feedback",
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated0Upto,
      component: () => import("@/views/Feedback"),
    },
    {
      path: "/my/course",
      name: "myCourse",
      props: (route) => ({
        routeParams: route.query,
      }),
      meta: {
        menuIndex: "1",
      },
      beforeEnter: ifAuthenticated0,
      component: () => import("@/views/MyCourse"),
    },
    {
      path: "/course/score",
      name: "courseScore",
      meta: {
        menuIndex: "2",
      },
      beforeEnter: ifAuthenticated0,
      component: () => import("@/views/CourseScore"),
    },
    {
      path: "/certificate",
      name: "certificate",
      meta: {
        menuIndex: "3",
      },
      beforeEnter: ifAuthenticated0,
      component: () => import("@/views/Certificate"),
    },
    {
      path: "/notification",
      name: "notification",
      meta: {
        menuIndex: "4",
      },
      beforeEnter: ifAuthenticated,
      component: () => import("@/views/Notification"),
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        menuIndex: "5",
      },
      beforeEnter: ifAuthenticated,
      component: () => import("@/views/Profile"),
    },
    {
      path: "/search",
      name: "search",
      props: (route) => ({
        routeParams: route.query,
      }),
      component: () => import("@/views/Search"),
    },
    {
      path: "/manage/course/list",
      name: "manageCourseList",
      meta: {
        menuIndex: "1",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/ManageCourseList"),
    },
    {
      path: "/manage/course/create",
      name: "manageCourseCreate",
      meta: {
        menuIndex: "1",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/ManageCourseCreate"),
    },
    {
      path: "/manage/course/update",
      name: "manageCourseUpdate",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/ManageCourseUpdate"),
    },
    {
      path: "/subject/create",
      name: "subjectCreate",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/SubjectCreate"),
    },
    {
      path: "/subject/update",
      name: "subjectUpdate",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/SubjectUpdate"),
    },
    {
      path: "/instructor/list",
      name: "instructorList",
      meta: {
        menuIndex: "2",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/InstructorList"),
    },
    {
      path: "/instructor/create",
      name: "instructorCreate",
      meta: {
        menuIndex: "2",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/InstructorCreate"),
    },
    {
      path: "/instructor/update",
      name: "instructorUpdate",
      meta: {
        menuIndex: "2",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/InstructorUpdate"),
    },
    {
      path: "/instructor/view",
      name: "instructorView",
      meta: {
        menuIndex: "2",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/InstructorView"),
    },
    {
      path: "/name/list",
      name: "nameList",
      meta: {
        menuIndex: "3",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/NameList"),
    },
    {
      path: "/name/list/profile",
      name: "nameListProfile",
      meta: {
        menuIndex: "3",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/NameListProfile"),
    },
    {
      path: "/name/list/activity",
      name: "nameListActivity",
      meta: {
        menuIndex: "3",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/NameListActivity"),
    },
    {
      path: "/name/list/grudate",
      name: "nameListGrudate",
      meta: {
        menuIndex: "3",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/NameListGrudate"),
    },
    {
      path: "/name/list/learning",
      name: "nameListLearning",
      meta: {
        menuIndex: "3",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/NameListLearning"),
    },
    {
      path: "/name/list/course",
      name: "nameListCourse",
      meta: {
        menuIndex: "3",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/NameListCourse"),
    },
        {
      path: "/manage/activity/score",
      name: "manageActivityScore",
      meta: {
        menuIndex: "4",
      },
      beforeEnter: ifAuthenticated50Upto,
      component: () => import("@/views/ManageActivityScore"),
    },
    {
      path: "/activity/total/score",
      name: "activityTotalScoreDetail",
      meta: {
        menuIndex: "4",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50Upto,
      component: () => import("@/views/ActivityTotalScoreDetail"),
    },
    {
      path: "/manage/activity/subject/list",
      name: "manageActivitySubjectList",
      meta: {
        menuIndex: "4",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50Upto,
      component: () => import("@/views/ManageActivitySubjectList"),
    },
    {
      path: "/activity/assigment",
      name: "activityAssigment",
      meta: {
        menuIndex: "4",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50Upto,
      component: () => import("@/views/ActivityAssigment"),
    },
    {
      path: "/summary/name/list",
      name: "summaryNameList",
      meta: {
        menuIndex: "5",
      },
      beforeEnter: ifAuthenticated50Upto,
      component: () => import("@/views/SummaryNameList"),
    },

    {
      path: "/feedback/name/list",
      name: "feedbackNameList",
      meta: {
        menuIndex: "6",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/FeedbackNameList"),
    },
    {
      path: "/feedback/view",
      name: "feedbackView",
      meta: {
        menuIndex: "6",
      },
      beforeEnter: ifAuthenticated60Upto,
      props: (route) => ({
        routeParams: route.query,
      }),
      component: () => import("@/views/FeedbackView"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        menuIndex: "7",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/Dashboard"),
    },
    {
      path: "/dashboard/detail",
      name: "dashboardDetail",
      meta: {
        menuIndex: "7",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/DashboardDetail"),
    },
    {
      path: "/dashboard/user/score",
      name: "dashboardUserScore",
      meta: {
        menuIndex: "7",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/DashboardUserScore"),
    },
    {
      path: "/manage/general",
      name: "manageGeneral",
      meta: {
        menuIndex: "8",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/ManageGeneral"),
    },
    {
      path: "/admin/list",
      name: "adminList",
      meta: {
        menuIndex: "9",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/AdminList"),
    },
    {
      path: "/admin/create",
      name: "adminCreate",
      meta: {
        menuIndex: "9",
      },
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/AdminCreate"),
    },
    {
      path: "/admin/update",
      name: "adminUpdate",
      meta: {
        menuIndex: "9",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated60Upto,
      component: () => import("@/views/AdminUpdate"),
    },
    {
      path: "/certificate/share",
      name: "certificateShare",
      props: (route) => ({
        routeParams: route.query,
      }),
      component: () => import("@/views/CertificateShare"),
    },
    {
      path: "/manage/course/instructor",
      name: "manageCourseInstructor",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50,
      component: () => import("@/views/ManageCourseInstructor"),
    },
    {
      path: "/manage/discussion/forum",
      name: "manageDiscussionForum",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50,
      component: () => import("@/views/ManageDiscussionForum"),
    },
    {
      path: "/manage/assignment",
      name: "manageAssignment",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50,
      component: () => import("@/views/ManageAssignment"),
    },
    {
      path: "/manage/assignment/check",
      name: "manageAssignmentCheck",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50,
      component: () => import("@/views/ManageAssignmentCheck"),
    },
    {
      path: "/view/assigment",
      name: "viewAssigment",
      meta: {
        menuIndex: "1",
      },
      props: (route) => ({
        routeParams: route.query,
      }),
      beforeEnter: ifAuthenticated50Upto,
      component: () => import("@/views/ActivityAssigment"),
    },
  ],
});

export default router;
